import _ from 'lodash';
import fontDetailsBase from './fontDetailsBase';

const fontDetails = _.mapValues(fontDetailsBase, detail => ({ ...detail, lineHeight: `${detail.lineHeight}px`, fontFamily: 'Helvetica Now Text SA' }));

export default fontDetails;
